import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { UserRole } from '../data/UpuServiceDataCertificationRequestModel';
import { UserApi } from '../features/user/user-api';
import { ROUTE_DATA } from './route-data';

export const systemSettingsGuardGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userApi = inject(UserApi);

  return (
    userApi.userRole() === UserRole.Superuser ||
    userApi.userRole() === UserRole.Administrator ||
    router.createUrlTree([ROUTE_DATA['access-restricted'].path])
  );
};
